import React, {useContext} from 'react'
import OrganizationListPageTemplate from '../../../components/Templates/OrganizationListPageTemplate'
import LinkCell3 from '../../../components/Pages/TablePage/Table/Cells/LinkCell3/LinkCell3'
import {AuthContext} from "../../../context/AuthContext";

function AllOrgList() {

  const { REACT_APP_URL_PREFIX } = process.env

    const {token} = useContext(AuthContext)
  const linkCell = (props) => {
    return <LinkCell3
      linkRoute={REACT_APP_URL_PREFIX + `/counterAgents/orgList/${props.idArr[0]}/${props.cellContent}/orgHistory`}
      linkTitle={props.cellContent}
    />
  }


  return (
    <OrganizationListPageTemplate
      getOrgListAPI={`/api/v2/medCenters/${token.userId}/organizations?`}
      addOrgIsShow={false}
      filterFieldsConf={{
        org: true,
        inn: true,
        date: true,
        period: true
      }}
      tableModel={{
        firstRow:
          [
            { title: 'Организация', id: 'org_name' },
            { title: 'Количество людей', id: '' }, // Сортировка не добавлена
            { title: 'Вызов', id: '' }, // Сортировка не добавлена
            { title: 'Исследований', id: '' } // Сортировка не добавлена
          ],
        haveToShow:
          [
            { id: 'name', type: 'reactRouterCell', idArr: ['id'], typeData: { cell: linkCell } },
            { id: 'patients_count' },
            { id: 'invite_count' },
            { id: 'patients_count' }

          ]
      }}
      filterFileds
      breadCrumbsItems={[
        { title: 'Контрагенты', link: REACT_APP_URL_PREFIX + '/counterAgents/orgList' },
        { title: 'Все', link: REACT_APP_URL_PREFIX + `/counterAgents/orgList`, actual: true }
      ]} />
  )
}

export default AllOrgList;
